import "../_namespaces.js";
import "./base.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Models ??= {};

AssessmentViewer.Models.Response = class Response extends AssessmentViewer.Models.Base {
  defaults() {
    return {
      selected: false,
      image: null,
    };
  }
};
